import { render, staticRenderFns } from "./GoogleAddressList.vue?vue&type=template&id=bc4a20f8&scoped=true&"
import script from "./GoogleAddressList.vue?vue&type=script&lang=js&"
export * from "./GoogleAddressList.vue?vue&type=script&lang=js&"
import style0 from "./GoogleAddressList.vue?vue&type=style&index=0&id=bc4a20f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4a20f8",
  null
  
)

export default component.exports